var map = {
	"./test-chto-eto-znachit.json": 159,
	"./test-chto-vy-znaete-ob-istorii-interneta.json": 160,
	"./test-chto-vy-znayete-o-memakh.json": 161,
	"./test-eto-normalno-ili-opasno.json": 162,
	"./test-hey-chat-kak-dela-data.json": 163,
	"./test-nub-guru-data.json": 49,
	"./test-prilichnom-obshhestve-znaete-li-vy-setevoj-jetiket.json": 164,
	"./test-vu-vse-pravilno-obyasnili.json": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 158;